import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const IconTextButtonStyles = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  color: theme.palette.primary.main,
  border: `0.5px solid ${theme.palette.primary.main}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0.2),
  paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(0.5),
  cursor: "pointer",
  // Ensure button children don't block clicks
  '& *': {
    pointerEvents: 'none',
  },
  // Re-enable pointer events on root
  pointerEvents: 'all',
  transition: "background-color 0.3s ease",
  '&.search-button': {
    // You can add specific styles here if needed
  },
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    border: `0.5px solid ${theme.palette.primary.main}`,
  },
}));

export default IconTextButtonStyles;
